import axios from 'axios';
import { t } from 'i18next'
import React from 'react'
import { useState, useEffect } from 'react';
import { config, url } from '../Components/Helpers/Help';
import Layout from '../Components/Layout'
const Buy = () => {
     const [buy, setBuy] = useState();


     useEffect(() => {
          axios(url + "content ", config).then((response) => {
               setBuy(response.data.data.buy)
          });
     }, []); 
     return (
          <Layout>
               <main className="container mx-auto pt-36 md:pt-28 px-4 md:px-0">
                    <div className="row flex items-start justify-center flex-wrap min-h-[70vh]">
                         <div className="w-full md:w-8/12 p-4 xl:px-6">
                              {buy && <div className="bg-white shadow rounded-2xl p-8">
                                   <div dangerouslySetInnerHTML={{ __html: buy }} />
                              </div>}

                         </div>
                    </div>
               </main>
          </Layout>

     )
}

export default Buy